/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Getting_Started__DescriptionInputs */

const en_help_center__getting_started__description = /** @type {(inputs: Help_Center__Getting_Started__DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn the basics of BidBattles and how to join your first auction`)
};

/**
* | output |
* | --- |
* | "Learn the basics of BidBattles and how to join your first auction" |
*
* @param {Help_Center__Getting_Started__DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__getting_started__description = /** @type {((inputs?: Help_Center__Getting_Started__DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Getting_Started__DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__getting_started__description(inputs)
});